import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";

interface PageHeaderProps {
  titleKey: string;
  subtitleKey: string;
}

export default function PageHeader({ titleKey, subtitleKey }: PageHeaderProps) {
  const { t } = useLanguage();

  return (
    <section className="bg-primary-deep pt-32 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="content-container">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="font-display font-extrabold text-white text-3xl md:text-4xl lg:text-5xl leading-tight"
        >
          {t(titleKey)}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.6,
            delay: 0.15,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="mt-4 text-lg text-white/70 max-w-3xl leading-relaxed"
        >
          {t(subtitleKey)}
        </motion.p>
      </div>
    </section>
  );
}
